import { compareSchool, School } from 'src/app/model/school.model';

import { FormsModule } from '@angular/forms';
import { PostalAddressService } from './location/service/postal-address.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { InputEmailService } from './input-email/service/input-email.service';
import { InputEmailComponent } from './input-email/input-email.component';
import { MaterialModule } from './../../material/material.module';
import { MsgComponent } from './msg/msg.component';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { InputEmailConfirmComponent } from './input-email-confirm/input-email-confirm.component';
import { InputCityAutocompleteComponent } from './location/input-city-autocomplete/input-city-autocomplete.component';
import { InputStateAutocompleteComponent } from './location/input-state-autocomplete/input-state-autocomplete.component';
import { InputZipcodeAutocompleteComponent } from './location/input-zipcode-autocomplete/input-zipcode-autocomplete.component';
import { InputZipcodeComponent } from './location/input-zipcode/input-zipcode.component';
import { TelephoneValidatorDirective } from './directives/telephone-validator.directive';
import { NumericOnlyDirective } from './directives/numeric-only.directive';
import { SignPadTestComponent } from './sign-pad/sign-pad.component';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { InputOrganizationAutocompleteComponent } from './organizations/input-organization-autocomplete/input-organization-autocomplete.component';
import { OrganizationService } from './organizations/service/organization.service';
import { RegionDropdownComponent } from './region/region-dropdown/region-dropdown.component';
import { CountyDropdownComponent } from './county/county-dropdown/county-dropdown.component';

import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { EntityDataService, EntityDefinitionService, EntityMetadataMap } from '@ngrx/data';
import { RegionDataService } from './service/region-data.service';
import { CountyDataService } from './service/county-data.service';
import { compareCounty, County } from '../../model/county';
import { compareRegion, Region } from '../../model/region.model';
import { RegionEntityService } from './service/region-entity.service';
import { InputPasswordComponent } from './input-password/input-password.component';
import { InputPasswordConfirmComponent } from './input-password-confirm/input-password-confirm.component';
import { DistrictComponent } from './district/district.component';
import { DistrictEntityService } from './service/district-entity.service';
import { DistrictDataService } from './service/district-data.service';
import { SearchDistrictComponent } from './district/search-district/search-district.component';
import { SchoolDataService } from './service/school-data.service';
import { SchoolDropdownComponent } from './school/school-dropdown/school-dropdown.component';

import { compareDistrict, SchoolDistrict } from '../../model/schoolDistrict.model';
import { ConfirmPopoverComponent } from './confirm-popover/confirm-popover.component';
import { HelpTextComponent } from './help-text/help-text.component';
import { QuestionHelpTextComponent } from './question-help-text/question-help-text.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { SchoolYearComponent } from './school-year/school-year.component';
import { MsinAlertComponent } from './msin-alert/msin-alert.component';
//import { SchoolViewComponent } from './school-view/school-view.component';
import { DistrictDropdownComponent } from './district/district-dropdown/district-dropdown.component';
import { NgModelChangeDebouncedDirective } from './directives/ng-model-change-debounce.directive';
import { GradeDropdownComponent } from './grade-dropdown/grade-dropdown.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CustomDatepickerComponent } from './custom-datepicker/custom-datepicker.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CalComponent } from './custom-datepicker/cal-component/cal-component.component';
import { RolesComponent } from './roles/roles.component';
import { compareRole, Role } from 'src/app/model/roles';
import { RoleDataService } from './service/role-data.service';
import { AddressComponent } from './address/address.component';
import { PhoneComponent } from './phone/phone.component';
import { PopOverComponent } from './pop-over/pop-over.component';
import { ConfirmChangesComponent } from './confirm-changes/confirm-changes.component';
import { ServiceDropdownComponent } from './child-services/service-dropdown/service-dropdown.component';
import { ServicePeriodDropdownComponent } from './child-services/service-period-dropdown/service-period-dropdown.component';
import { ServiceCategoryDropdownComponent } from './child-services/service-category-dropdown/service-category-dropdown.component';
import { GeographicalDataService } from './service/geographical-data.service';
import { GeographicalRegions } from '../party/model/geographicalRegions.model';
import { ContactMechanismDataService } from './service/contact-mechanism-data.service';
import { ContactMechanismTypes } from '../party/model/contact-mechanism-types.model';
import { ContactMechanismPurposeDataService } from './service/contact-mechanism-purpose-data.service';
import { ContactMechanismPurposeTypes } from '../party/model/contact-mechanism-purpose-types.model';
import { PartyRoleTypes } from '../party/model/party-role-types.model';
import { PartyRoleTypeDataService } from './service/party-role-type-data.service';
import { TrackingHistoryComponent } from './tracking-history/tracking-history.component';
import { EmailComponent } from './email/email.component';
import { AppPingComponent } from './app-ping/app-ping.component';
import { InputCountryAutocompleteComponent } from './location/input-country-autocomplete/input-country-autocomplete.component';
import { InputSsidComponent } from './input-ssid/input-ssid.component';
import { MultiSelectCoeStudentComponent } from './multi-select-coe-student/multi-select-coe-student.component';
import { ViewCoeChildInfoComponent } from './view-coe-child-info/view-coe-child-info.component';
import { ReportTemplatesComponent } from './report-templates/report-templates.component';
import { CoursesectionDataService } from './service/coursesection-data.service';
import { CoursetypeDataService } from './service/coursetype-data.service';
import { TermtypeDataService } from './service/termtype-data.service';
import { CourseSection } from 'src/app/model/course-section';
import { CourseType } from 'src/app/model/course-type';
import { TermType } from 'src/app/model/term-type';
import { CommunicationEventPurposeType } from '../children/model/student-communication-events';
import { CommunicationEventPurposeTypeDataService } from './service/communication-event-purpose-type-data.service';
import { TelePhoneComponent } from './tele-phone/tele-phone.component'; // needed for NoSQL
import { ExportbtnComponent } from './exportbtn/exportbtn.component';
import { HelpTextBtnComponent } from './help-text/help-text-btn/help-text-btn.component';
import { EditHelpTextComponent } from './help-text/edit-help-text/edit-help-text.component';
import { PreviewHelpTextComponent } from './help-text/preview-help-text/preview-help-text.component';
import { SearchHelpTextsComponent } from './help-text/search-help-texts/search-help-texts.component';
import { RouterModule } from '@angular/router';
import { PreviewHelpTextBtnComponent } from './help-text/preview-help-text/preview-help-text-btn/preview-help-text-btn.component';
import { HelpTextService } from './help-text/service/help-text.service';
import { HelpTextStorageService } from './help-text/service/help-text-storage.service';
import { RegionDropdownTwoWayComponent } from './region/region-dropdown-two-way/region-dropdown-two-way.component';
import { CountyDropdownTwoWayComponent } from './county/county-dropdown-two-way/county-dropdown-two-way.component';
import { DistrictDropdownTwoWayComponent } from './district/district-dropdown-two-way/district-dropdown-two-way.component';
import { SchoolDropdownTwoWayComponent } from './school/school-dropdown-two-way/school-dropdown-two-way.component';
import { OnlyLettersDirective } from './directives/OnlyLettersDirective';
import { ConfirmSmallComponent } from 'src/app/component/common-components/confirm-small/confirm.small.component';
import { ErrorMsgDialogComponent } from './error-msg-dialog/error-msg-dialog.component';

const entityMetadata: EntityMetadataMap = {
    Region: {
        selectId: (region: Region) => region.ID,
        sortComparer: compareRegion,
        entityDispatcherOptions: {
            optimisticUpdate: true
        }
    },
    County: {
        selectId: (county: County) => parseInt(county.REGION?.ORGANIZATIONS_ID?.toString() + county.ORGANIZATIONS_ID.toString()),
        sortComparer: compareCounty,
        entityDispatcherOptions: {
            optimisticUpdate: true
        }
    },
    District: {
        selectId: (district: SchoolDistrict) =>
            parseInt(district.ORGANIZATIONS_ID.toString() + district.COUNTy?.ORGANIZATIONS_ID.toString() + district.REGION?.ORGANIZATIONS_ID.toString()),
        sortComparer: compareDistrict,
        entityDispatcherOptions: {
            optimisticUpdate: true
        }
    },
    School: {
        selectId: (school: School) => parseInt(school.ORGANIZATIONS_ID.toString()), // + school.COUNTY.ORGANIZATIONS_ID.toString() + school.REGION.ORGANIZATIONS_ID.toString()),
        sortComparer: compareSchool,
        entityDispatcherOptions: {
            optimisticUpdate: true
        }
    },
    Role: {
        selectId: (role: Role) => role.ID,
        sortComparer: compareRole,
        entityDispatcherOptions: {
            optimisticUpdate: true
        }
    },
    Geographical: {
        selectId: (geographicalRegion: GeographicalRegions) => geographicalRegion.ID,
        entityDispatcherOptions: {
            optimisticUpdate: true
        }
    },
    ContactMechanism: {
        selectId: (contactMechanismTypes: ContactMechanismTypes) => contactMechanismTypes.ID,
        entityDispatcherOptions: {
            optimisticUpdate: true
        }
    },
    ContactMechanismPurpose: {
        selectId: (contactMechanismPurposeTypes: ContactMechanismPurposeTypes) => contactMechanismPurposeTypes.ID,
        entityDispatcherOptions: {
            optimisticUpdate: true
        }
    },
    PartyRoleTypes: {
        selectId: (partyRoleTypes: PartyRoleTypes) => partyRoleTypes.ID,
        entityDispatcherOptions: {
            optimisticUpdate: true
        }
    },
    CourseSection: {
        selectId: (courseSection: CourseSection) => courseSection.ID,
        entityDispatcherOptions: {
            optimisticUpdate: true
        }
    },
    CourseType: {
        selectId: (courseType: CourseType) => courseType.ID,
        entityDispatcherOptions: {
            optimisticUpdate: true
        }
    },
    TermType: {
        selectId: (termType: TermType) => termType.ID,
        entityDispatcherOptions: {
            optimisticUpdate: true
        }
    },
    CommunicationEventPurposeType: {
        selectId: (communicationEventPurposeTypes: CommunicationEventPurposeType) => communicationEventPurposeTypes.ID,
        entityDispatcherOptions: {
            optimisticUpdate: true
        }
    }
};

const components = [
    MsgComponent,
    InputEmailComponent,
    InputEmailConfirmComponent,
    InputCityAutocompleteComponent,
    InputStateAutocompleteComponent,
    InputCountryAutocompleteComponent,
    InputZipcodeAutocompleteComponent,
    InputZipcodeComponent,
    TelephoneValidatorDirective,
    NumericOnlyDirective,
    OnlyLettersDirective,
    SignPadTestComponent,
    InputOrganizationAutocompleteComponent,
    RegionDropdownComponent,
    CountyDropdownComponent,
    InputPasswordComponent,
    InputPasswordConfirmComponent,
    DistrictComponent,
    SearchDistrictComponent,
    ConfirmPopoverComponent,
    HelpTextComponent,
    HelpTextBtnComponent,
    SearchHelpTextsComponent,
    PreviewHelpTextBtnComponent,
    EditHelpTextComponent,
    PreviewHelpTextComponent,
    QuestionHelpTextComponent,
    SchoolYearComponent,
    SchoolDropdownComponent,
    MsinAlertComponent,
    DistrictDropdownComponent,
    NgModelChangeDebouncedDirective,
    GradeDropdownComponent,
    DropdownComponent,
    CustomDatepickerComponent,
    CalComponent,
    RolesComponent,
    AddressComponent,
    PhoneComponent,
    EmailComponent,
    PopOverComponent,
    ConfirmChangesComponent,
    ServiceDropdownComponent,
    ServicePeriodDropdownComponent,
    ServiceCategoryDropdownComponent,
    TrackingHistoryComponent,
    AppPingComponent,
    InputSsidComponent,
    ViewCoeChildInfoComponent,
    ReportTemplatesComponent,
    TelePhoneComponent,
    ExportbtnComponent,
    RegionDropdownTwoWayComponent,
    CountyDropdownTwoWayComponent,
    DistrictDropdownTwoWayComponent,
    SchoolDropdownTwoWayComponent,
    ConfirmSmallComponent,
	ErrorMsgDialogComponent
];

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [components, MultiSelectCoeStudentComponent],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatNativeDateModule,
        MatSlideToggleModule,
        FormsModule,
        PipesModule,
        AngularSignaturePadModule,
        MatProgressSpinnerModule,
        MatDatepickerModule,
        RouterModule
    ],
    exports: [components]
})
export class CommonComponentsModule {
    constructor(
        private eds: EntityDefinitionService,
        private entityDataService: EntityDataService,
        private regionDataService: RegionDataService,
        private countyDataService: CountyDataService,
        private districtDataService: DistrictDataService,
        private schoolDataService: SchoolDataService,
        private roleDataService: RoleDataService,
        private geographicalDataService: GeographicalDataService,
        private contactMechanismDataService: ContactMechanismDataService,
        private contactMechanismPurposeDataService: ContactMechanismPurposeDataService,
        private partyRoleTypeDataService: PartyRoleTypeDataService,
        private courseSectionDataService: CoursesectionDataService,
        private coursetypeDataService: CoursetypeDataService,
        private termyTypeDataService: TermtypeDataService,
        private communicationEventPurposeTypeDataService: CommunicationEventPurposeTypeDataService
    ) {
        eds.registerMetadataMap(entityMetadata);
        entityDataService.registerService('Region', regionDataService);
        entityDataService.registerService('County', countyDataService);
        entityDataService.registerService('District', districtDataService);
        entityDataService.registerService('School', schoolDataService);
        entityDataService.registerService('Role', roleDataService);
        entityDataService.registerService('Geographical', geographicalDataService);
        entityDataService.registerService('ContactMechanism', contactMechanismDataService);
        entityDataService.registerService('ContactMechanismPurpose', contactMechanismPurposeDataService);
        entityDataService.registerService('PartyRoleTypes', partyRoleTypeDataService);
        entityDataService.registerService('CourseSection', courseSectionDataService);
        entityDataService.registerService('CourseType', coursetypeDataService);
        entityDataService.registerService('TermType', termyTypeDataService);
        entityDataService.registerService('CommunicationEventPurposeType', communicationEventPurposeTypeDataService);
    }

    static forRoot(): ModuleWithProviders<CommonComponentsModule> {
        return {
            ngModule: CommonComponentsModule,
            providers: [
                InputEmailService,
                PostalAddressService,
                OrganizationService,
                RegionEntityService,
                RegionDataService,
                CountyDataService,
                DistrictEntityService,
                DistrictDataService,
                SchoolDataService,
                RoleDataService,
                GeographicalDataService,
                ContactMechanismDataService,
                ContactMechanismPurposeDataService,
                PartyRoleTypeDataService,
                CoursesectionDataService,
                CoursetypeDataService,
                TermtypeDataService,
                CommunicationEventPurposeTypeDataService,
                HelpTextService,
                HelpTextStorageService
            ]
        };
    }
}
